var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.9994L12.3248 13.9977C12.808 13.9977 13.2 13.5053 13.2 12.8983V8.39941H0V13.9994Z",
    fill: "#00538A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.2,
    height: 8.8,
    fill: "#00538A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10938 1.2002L10.6219 4.65005C10.818 4.84245 10.818 5.15868 10.6219 5.35108L7.11085 8.8002V6.87182L8.76059 5.24419C8.89622 5.11003 8.89622 4.89036 8.76059 4.7562L7.10938 3.12342V1.2002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46036 1.2002L2.94784 4.65005C2.75176 4.84245 2.75176 5.15868 2.94784 5.35108L6.45888 8.8002V6.87182L4.80914 5.24419C4.67351 5.11003 4.67351 4.89036 4.80914 4.7562L6.46036 3.12342V1.2002Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82895 11.5516L4.47673 10.4401L4.13183 11.5516H4.82858H4.82895ZM4.80993 10.0732L5.60507 12.4236H5.10509L4.94599 11.9367H4.0104L3.84764 12.4236H3.34766L4.08245 10.2528C4.11866 10.1457 4.21961 10.0732 4.33262 10.0732H4.80956H4.80993Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07714 11.8264C7.07714 11.9994 6.98606 12.0557 6.77027 12.0557H6.28163V11.4135H6.81197C7.00143 11.4135 7.07714 11.491 7.07714 11.6497V11.826V11.8264ZM6.28163 10.4395H6.73991C6.91401 10.4395 6.99009 10.4995 6.99009 10.63V10.8381C6.99009 10.9757 6.92206 11.0569 6.73626 11.0569H6.28163V10.4391V10.4395ZM7.18686 11.198C7.37998 11.1205 7.46739 11.0111 7.46739 10.8169V10.5733C7.46739 10.2559 7.27428 10.0723 6.79697 10.0723H5.80469V12.4226H6.86537C7.32365 12.4226 7.55481 12.2145 7.55481 11.8827V11.6322C7.55481 11.4029 7.41838 11.2438 7.18723 11.198",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47754 10.4034H3.16332V10.233C3.16332 10.1042 3.05908 10 2.93034 10H2.47754C1.86454 10.0059 1.60156 10.2553 1.60156 10.6807V11.7391C1.60156 12.1645 1.8649 12.414 2.47754 12.4198V12.4216H3.13735V12.2508C3.13735 12.1225 3.03348 12.0182 2.90473 12.0182H2.47754V12.0164C2.17835 12.008 2.0785 11.9023 2.0785 11.6616V10.7582C2.0785 10.5175 2.17835 10.4118 2.47754 10.4034Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5629 12.0314V10.0381H10.35C10.2041 10.0381 10.0859 10.1566 10.0859 10.3022V12.4228H11.6005V12.0311H10.5629V12.0314Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14181 11.5516L8.78959 10.4401L8.44469 11.5516H9.14145H9.14181ZM9.12279 10.0732L9.91794 12.4236H9.41796L9.25885 11.9367H8.32326L8.16014 12.4236H7.66016L8.37227 10.319C8.42202 10.1724 8.5599 10.0732 8.71498 10.0732H9.12206H9.12279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabal);
export default __webpack_public_path__ + "static/media/cabal.6f9cf2e0fb52818fbe7b183749d3e551.svg";
export { ForwardRef as ReactComponent };